import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { StaticIcon } from 'web-components-ts';

export default function IrisCloudBrand() {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.25}
      sx={{
        width: 'fit-content',
        borderRadius: 1.5,
        p: 0,
        pb: 7
      }}
    >
      <StaticIcon
        name="IrisCloud"
        sx={{
          color: '#7AAAC0',
          fontSize: 52
        }}
      />

      <Box sx={{ position: 'relative', pr: 4 }}>
        <Typography
          component="span"
          sx={{
            color: 'white',
            fontWeight: 800,
            fontSize: 52,
            letterSpacing: 0.2,
            lineHeight: 1
          }}
        >
          IRIS
        </Typography>
        <Typography
          component="span"
          sx={{
            color: 'white',
            fontWeight: 600,
            fontSize: 52,
            letterSpacing: 0.2,
            lineHeight: 1,
            ml: 1
          }}
        >
          Cloud
        </Typography>
        <Box
          sx={{
            position: 'absolute',
            right: 33,
            bottom: -50,
            lineHeight: 1,
            opacity: 0.95
          }}
        >
          <StaticIcon
            name="NetzschLogo"
            sx={{
              color: 'white',
              fontSize: 64
            }}
          />
        </Box>
      </Box>
    </Stack>
  );
}
